import TDSHeader from './TDSHeader';

export default TDSHeader;
